import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ApiService from '../../services/api.service';

// Consumes the one-time token from the promoted TC's TC_ADMIN and establishes a portal session on
// the B2B's subdomain, then lands on the portal dashboard. No manual login.
const PortalAutoLogin = ({ onPortalLogin }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const ranRef = useRef(false);

  useEffect(() => {
    // Guard against React 18 StrictMode double-invoke — the token is single-use.
    if (ranRef.current) return;
    ranRef.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setError('Missing sign-in token.');
      return;
    }

    const run = async () => {
      try {
        const response = await ApiService.exchangePortalAutoLoginToken(token);
        if (response.data && response.data.success) {
          const data = response.data.data;
          const user = data.user;
          const organization = data.organization;

          localStorage.setItem('portalToken', data.token);
          localStorage.setItem('portalUser', JSON.stringify(user));
          localStorage.setItem('portalOrganization', JSON.stringify(organization));

          onPortalLogin({
            id: user.id,
            email: user.email,
            fullName: user.fullName,
            role: user.role,
            organizationId: user.internalOrganizationId,
            organizationName: organization?.name || '',
            docExpiryEnabled: organization?.docExpiryEnabled !== false,
            thaklisEnabled: organization?.thaklisEnabled !== false,
            token: data.token
          });

          navigate('/portal/dashboard', { replace: true });
        } else {
          setError('Sign-in failed. Please try again.');
        }
      } catch (err) {
        console.error('Portal auto-login failed:', err);
        setError(err.response?.data?.message || 'This sign-in link is invalid or has expired.');
      }
    };

    run();
  }, [searchParams, onPortalLogin, navigate]);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      backgroundColor: '#f8f9fa', colorScheme: 'light', padding: '24px'
    }}>
      <div style={{
        maxWidth: '420px', width: '100%', backgroundColor: '#ffffff', borderRadius: '12px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)', padding: '32px', textAlign: 'center'
      }}>
        {error ? (
          <>
            <h2 style={{ fontSize: '1.1rem', fontWeight: 600, color: '#b91c1c', marginBottom: '12px' }}>
              Could not sign you in
            </h2>
            <p style={{ fontSize: '0.9rem', color: '#555', marginBottom: '20px' }}>{error}</p>
            <a href="/portal/login" style={{ fontSize: '0.85rem', color: '#1a1a1a', fontWeight: 600 }}>
              Go to portal login
            </a>
          </>
        ) : (
          <>
            <h2 style={{ fontSize: '1.1rem', fontWeight: 600, color: '#1a1a1a', marginBottom: '12px' }}>
              Signing you in…
            </h2>
            <p style={{ fontSize: '0.9rem', color: '#555' }}>Opening your B2B portal.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default PortalAutoLogin;
